import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const TitleWrapper = styled(Flex)`
  line-height: 1.2;
  font-weight: ${(props) => props.fontWeight};
  color: ${textColor};
  cursor: ${(props) => (props.clickable ? 'pointer' : 'inherit')}
`;

function Title(props) {
  const {
    buttons, fontSize, fontWeight, children, clickable, ...otherProps
  } = props;
  return (
    <Flex
      justifyContent="space-between"
      flexWrap="wrap"
      mb={4}
      fontSize={2}
      flexShrink={0}
      {...otherProps}
    >
      <TitleWrapper
        fontSize={fontSize}
        fontWeight={fontWeight}
        mr={buttons ? 2 : 0}
        alignItems="center"
        clickable={clickable}
      >
        {children}
      </TitleWrapper>
      {buttons && <Flex flexWrap="wrap">{buttons}</Flex>}
    </Flex>
  );
}

Title.defaultProps = {
  clickable: false,
  buttons: [],
  fontSize: 2,
  fontWeight: 400,
};

Title.propTypes = {
  clickable: PropTypes.bool,
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
  buttons: PropTypes.arrayOf(PropTypes.node.isRequired),
};

export default Title;
